import PropTypes from 'prop-types';
import { HelpCircle } from 'lucide-react';

import { cn } from '#/lib/utils';
import ResponsiveHint from '#/modules/commonComponents/hint/ResponsiveHint';

const HINT_TONE_CLASS = {
  default: 'text-gray-400 hover:text-primary-600',
  inherit: 'text-current hover:text-current/80',
};

/**
 * 按鈕內 ? 說明：桌面延遲 Tooltip／觸控 Popover。
 */
const ActionHintIcon = ({
  tip,
  ariaLabel,
  tone = 'default',
  iconSize = 14,
  className,
}) => (
  <ResponsiveHint content={tip}>
    <button
      type="button"
      className={cn(
        'pointer-events-auto inline-flex cursor-help items-center border-0 bg-transparent p-0',
        HINT_TONE_CLASS[tone] ?? HINT_TONE_CLASS.default,
        className,
      )}
      aria-label={ariaLabel}
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
    >
      <HelpCircle size={iconSize} aria-hidden />
    </button>
  </ResponsiveHint>
);

ActionHintIcon.propTypes = {
  tip: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  tone: PropTypes.oneOf(['default', 'inherit']),
  iconSize: PropTypes.number,
  className: PropTypes.string,
};

export default ActionHintIcon;
